import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        username: '',
        language: ''
    },
    mutations: {
        changeusername(state, username) {
            state.username = username
        },

        SET_LANGUAGE: (state, language) => {
            state.language = language
        },
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js